module.exports = __webpack_public_path__ + "static/media/C_E02.48342b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_E02.png
// module id = 122
// module chunks = 0